/**
 * External dependencies.
 */
import { createContext } from '@wordpress/element';

export default createContext( {} );
